const SIGNED_LINE_MARKET_KEYWORDS = ['spread', 'handicap', 'run-line'] as const;
const LINE_MARKET_KEYWORDS = [...SIGNED_LINE_MARKET_KEYWORDS, 'over-under'] as const;
const SIGNED_LINE_PLACEHOLDER = '${signed-line}';

const matchesKeyword = (value: string | null | undefined, keywords: ReadonlyArray<string>): boolean => {
    return keywords.some((keyword) => value?.includes(keyword) === true);
};

export const isLineMarket = (templateId: string | null | undefined): boolean => {
    return matchesKeyword(templateId, LINE_MARKET_KEYWORDS);
};

export const isSignedLineMarket = (templateId: string | null | undefined, templateName?: string | null): boolean => {
    return (
        templateName?.includes(SIGNED_LINE_PLACEHOLDER) === true ||
        matchesKeyword(templateId, SIGNED_LINE_MARKET_KEYWORDS)
    );
};

export const isSignedLineMarketName = (marketName: string): boolean => {
    return matchesKeyword(marketName.toLowerCase(), SIGNED_LINE_MARKET_KEYWORDS);
};

export const resolveSignedLineLabel = (
    selectionIdentifier: string | undefined,
    line: number | null
): string | undefined => {
    if (line === null || selectionIdentifier === undefined) {
        return undefined;
    }

    const signedLine = selectionIdentifier === 'A' ? line : -line;

    return `${signedLine > 0 ? '+' : ''}${signedLine}`;
};
